import { DeployEnvironment, envConfig } from '@globals/env'
import AppPaths from '@globals/paths'
import FeatureFlags from '@guest/featureFlags'
import KudosTvRoute from '@guest/kudosTv'
import MaintenanceRoute from '@guest/maintenance'
import guestRoutes from '@guest/routes'
import TenantLoginRoute from '@guest/tenantLogin'
import ConstrainedWidthLayout from '@layouts/ConstrainedWidthLayout'
import { RouteUpdateProvider } from '@layouts/RouteUpdateContext'
import NotFound from '@shared/routing/NotFound'
import RouteLoading from '@shared/routing/RouteLoading'
import tenantScopeRoutes from '@tenant/routes'
import { Suspense } from 'react'
import { Outlet, RouteObject, ScrollRestoration } from 'react-router'
import { AwaitAuth } from './AwaitAuth'
import DocumentTitleWrapper from './DocumentTitleWrapper'
import AppRoutesErrorElement from './errors'
import { GuestRoutes } from './GuestRoutes'
import Logout from './protected/logout'
import userScopeRoutes from './protected/user/routes'
import RouteReloader from './RouteReloader'
import { TenantScopeRoutes } from './TenantScopeRoutes'
import { UserScopeRoutes } from './UserScopeRoutes'

const appRoutes: RouteObject[] = [
  {
    element: (
      <>
        <ScrollRestoration />
        <RouteReloader />
        <Outlet />
      </>
    ),
    errorElement: <AppRoutesErrorElement />,
    children: [
      {
        path: AppPaths.anon.tenantLogin(),
        element: <TenantLoginRoute />,
      },
      {
        path: AppPaths.anon.watchKudosTv(':tvToken'),
        element: <KudosTvRoute />,
      },
      {
        path: AppPaths.anon.maintenance(),
        element: (
          <ConstrainedWidthLayout>
            <Suspense fallback={<RouteLoading />}>
              <MaintenanceRoute />
            </Suspense>
          </ConstrainedWidthLayout>
        ),
      },
      {
        element: (
          <RouteUpdateProvider>
            <DocumentTitleWrapper>
              <AwaitAuth />
            </DocumentTitleWrapper>
          </RouteUpdateProvider>
        ),
        children: [
          // Unauthenticated routes
          {
            element: <GuestRoutes />,
            children: guestRoutes,
          },
          // Authenticated Routes
          {
            path: AppPaths.logout(),
            element: <Logout />,
          },
          {
            element: <UserScopeRoutes />,
            children: userScopeRoutes,
          },
          {
            element: <TenantScopeRoutes />,
            children: tenantScopeRoutes,
          },
        ],
      },
      {
        path: AppPaths.anon.featureFlags(),
        element:
          envConfig.DEPLOY_ENVIRONMENT !== DeployEnvironment.PRODUCTION ? (
            <FeatureFlags />
          ) : (
            <NotFound to={AppPaths.tenant.home()} />
          ),
      },
      {
        path: '*',
        element: <NotFound to={AppPaths.tenant.home()} />,
      },
    ],
  },
]

export default appRoutes
